import { TextTemplate } from "./TextTransformer";

export const textTemplates: TextTemplate[] = [
    {
        id: "speaker_announcement",
        name: "Speaker Announcement",
        description: "Announcement of a new Speaker of an Event"
    },
    {
        id: "exponat_announcement",
        name: "Exponat Announcement",
        description: "Announcement of a new Exponat of an Event"
    },
    {
        id:"event_announcement",
        name: "Event Announcement",
        description: "Announcement of a new upcoming event"
    },
    {
        id:"event_attendance_announcement",
        name: "Event Attendace Announcement",
        description: "Announcement of the attendace of a new upcoming event"
    },
    {
        id:"event_review",
        name: "Event Review",
        description: "Report of an experience of a recent event"
    },
    {
        id: "short_post",
        name: "LinkedIn Short Post",
        description: "Short Informational Post"
    },
    {
        id: "first_spirit",
        name: "Webseite Newsartikel",
        description: "News Article First Spirit"
    },
    {
        id: "first_spirit_referenten",
        name: "Webseite Referentenbeschreibung",
        description: "Info in Webseiten-Layout"
    },
]